import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_CONSTRUCTOR_BEGIN,
  COLLECTIONS_DELETE_CONSTRUCTOR_SUCCESS,
  COLLECTIONS_DELETE_CONSTRUCTOR_FAILURE,
  COLLECTIONS_DELETE_CONSTRUCTOR_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteConstructor(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_CONSTRUCTOR_BEGIN,
    });
    const { projectId, collectionUuid, constructorId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/constructors/${collectionUuid}/collection/${constructorId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_CONSTRUCTOR_SUCCESS,
              data: res.data,
              collectionUuid: args.collectionUuid,
            });
            Mixpanel.track('Deleted collection constructor');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_CONSTRUCTOR_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection constructor');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_CONSTRUCTOR_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection constructor');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteConstructorError() {
  return {
    type: COLLECTIONS_DELETE_CONSTRUCTOR_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_CONSTRUCTOR_BEGIN:
      return {
        ...state,
        deleteConstructorPending: true,
        deleteConstructorError: null,
      };

    case COLLECTIONS_DELETE_CONSTRUCTOR_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        deleteConstructorPending: false,
        deleteConstructorError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          constructors: action.data,
        },
      };

    case COLLECTIONS_DELETE_CONSTRUCTOR_FAILURE:
      return {
        ...state,
        deleteConstructorPending: false,
        deleteConstructorError: action.data.error,
      };

    case COLLECTIONS_DELETE_CONSTRUCTOR_DISMISS_ERROR:
      return {
        ...state,
        deleteConstructorError: null,
      };

    default:
      return state;
  }
}
